import React, { useState } from "react";
import { BsChatLeft } from "react-icons/bs";
import ContactModal from "../../components/contact-modal/ContactModal";

const Contact = () => {
    const [contactModal, setContactModal] = useState(false);
    return (
        <div className="my-4 bg-blue20 w-full text-center" id="contact">
            <div className="w-full py-32 flex flex-col justify-center items-center">
                <h1 className="text-6xl text-secondary my-4 mb-8">What are you working on?</h1>
                <div className="text-center sm:w-1/2 lg:w-1/3">
                    <p className="text-xl text-white font-medium">
                        Let's have a conversation! I'd love to hear about what you're working on and find a way to work
                        together.
                    </p>
                </div>
                <div
                    className="bg-secondary p-3 px-4 mt-12 rounded-xl cursor-pointer"
                    onClick={() => setContactModal(true)}
                >
                    <span className="flex justify-center items-center font-bold text-lg">
                        <BsChatLeft style={{ marginRight: "12px", fontWeight: "bold" }} />
                        Chat
                    </span>
                </div>
            </div>
            <ContactModal isOpen={contactModal} setIsOpen={setContactModal} />
        </div>
    );
};

export default Contact;
